import { useAuth } from '@/hooks/useAuth'

/**
 * Template-grade dashboard scaffold.
 *
 * Ships as a minimal post-login landing page. Downstream projects extend
 * with widgets, count tiles, activity feeds, etc. — typically by composing
 * smaller `useQuery`-backed components and dropping them in this file.
 */
export function DashboardPage() {
	const { user } = useAuth()

	return (
		<div className="space-y-6">
			<div>
				<h1 className="text-2xl font-bold text-ds-text">Dashboard</h1>
				<p className="text-sm text-ds-text-muted mt-1">Welcome{user ? `, ${user.displayName || user.email}` : ''}.</p>
			</div>

			<div className="rounded-lg border border-dashed border-ds-border-strong p-8 text-center">
				<p className="text-sm text-ds-text-muted">This is a scaffold dashboard. Add widgets for your project here.</p>
			</div>
		</div>
	)
}
